import api from "@core/plugins/api";

const recapDemandPermanentUrl = (demandId) => `/api/et/recap-cdi/${demandId}`;

export class ActivationService {
  static async getRecap({ demandId }) {
    try {
      const { data } = await api.private.get(recapDemandPermanentUrl(demandId));
      return data;
    } catch (error) {
      throw error;
    }
  }
}
